import { OrgPermission } from '../../organisation/organisation-permission.js';

/** Audio types. Anything ffmpeg decodes. */
export const audioFileTypes = [
  '.aac',
  '.ac3',
  '.aif',
  '.aiff',
  '.amr',
  '.awb',
  '.caf',
  '.dss',
  '.flac',
  '.m4a',
  '.m4r',
  '.mp3',
  '.oga',
  '.ogg',
  '.opus',
  '.spx',
  '.wav',
  '.wave',
  '.wma',
];

/**
 * Video container: their audio track is extracted with ffmpeg downstream, same as the
 * {@link audioFileTypes}.
 */
export const videoFileTypes = [
  '.3g2',
  '.3gp',
  '.avi',
  '.flv',
  '.m4v',
  '.mkv',
  '.mov',
  '.mp4',
  '.mpeg',
  '.mpg',
  '.vob',
  '.webm',
  '.wmv',
];

/** All types processed via the ffmpeg audio-extraction path. */
export const audioVideoFileTypes = [...audioFileTypes, ...videoFileTypes];

export const allowedFileTypes = [
  '.csv',
  '.doc',
  '.docx',
  '.eml',
  '.fax',
  '.htm',
  '.html',
  '.img',
  '.jpeg',
  '.jpg',
  '.json',
  '.mht',
  '.mhtml',
  '.msg',
  '.pdf',
  '.png',
  '.ppt',
  '.pptx',
  '.pst',
  '.rtf',
  '.tif',
  '.tiff',
  '.txt',
  '.xls',
  '.xlsb',
  '.xlsx',
  '.zip',
  '.xlsm',
  ...audioVideoFileTypes,
];

/** File types offered only to orgs holding the corresponding feature flag. */
export const gatedFileTypes: Partial<Record<string, OrgPermission>> = {
  '.pst': OrgPermission.PstUploads,
};

/** The types an org may upload: {@link allowedFileTypes} minus flag-gated types the org lacks. */
export function permittedFileTypesForOrg(permissions: readonly OrgPermission[]): string[] {
  return allowedFileTypes.filter((ext) => {
    const gate = gatedFileTypes[ext];
    return gate === undefined || permissions.includes(gate);
  });
}
